/* eslint-disable no-shadow */

// initial state
import {createHelpers} from 'vuex-map-fields';

// initial state
const state = {
  tableOptions: {},
  filter: {
    tags: []
  }
};

// Because by default, getters and mutations in Vuex
// modules, are globally accessible and not namespaced,
// you most likely want to rename the getter and mutation
// helpers because otherwise you can't reuse them in multiple,
// non namespaced modules.
const {getAMacroField, mutateAMacroField} = createHelpers({
  getterType: 'getAMacroField',
  mutationType: 'mutateAMacroField'
});


// getters - all receive state as first argument
const getters = {
  getAMacroTableOptions: (state) => state.tableOptions,
  getAMacroFilter: (state) => state.filter,
  getAMacroField
};

// actions
const actions = {};

// mutations
const mutations = {
  setAMacroTableOptions(state, options) {
    state.tableOptions = options;
  },
  setAMacroFilter(state, filter) {
    state.filter = filter;
  },
  appendAMacroTag(state, tag) {
    if (!state.filter.tags.includes(tag)) {
      state.filter.tags.push(tag);
    } else {
      state.filter.tags = state.filter.tags.filter((t) => t !== tag);
    }
  },
  mutateAMacroField
};

export default {
  state,
  getters,
  actions,
  mutations
};
